import { render, staticRenderFns } from "./loginHeader.vue?vue&type=template&id=5be229dc&scoped=true"
var script = {}
import style0 from "./loginHeader.vue?vue&type=style&index=0&id=5be229dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be229dc",
  null
  
)

export default component.exports